import { createReducer } from './Utils';
import { FunctionMap, InfluencerState } from '../../types';
import { FSAInterface, SetInfluencer, SetInfToken } from '../actions';
import {
  INF_CLEAR_SOCIAL_TOKEN_REQUEST,
  INF_CLEAR_SOCIAL_TOKEN_SUCCESS,
  INF_SET_ASSOCIATED_FBPAGE_REQUEST,
  INF_SET_ASSOCIATED_FBPAGE_SUCCESS,
  INF_SET_FB_TOKEN_SUCCESS,
  INF_SET_TWITTER_ACC_TOKEN_SUCCESS,
  INF_SET_YOUTUBE_ACC_TOKEN_SUCCESS,
  SUBMIT_INFLUENCER_PERSONAL_SUCCESS,
} from '../constants';
import get from 'lodash/fp/get';
import { clearEntitySocialToken, setEntityAssociatedFBPage } from './common/Entity';

const initialState = {};

function setInfluencer(state: InfluencerState, action: FSAInterface<SetInfluencer['payload']>) {
  const infObj = {
    _id: get('payload._id', action),
  };
  return { ...state, ...infObj };
}

function setSocialToken(state: InfluencerState, action: FSAInterface<SetInfToken['payload']>) {
  const newNetwork = get('payload.socialNetworks', action);
  return { ...state, socialNetworks: { ...state.socialNetworks, ...newNetwork } };
}

const functionMap: FunctionMap = {
  [SUBMIT_INFLUENCER_PERSONAL_SUCCESS]: setInfluencer,
  [INF_SET_FB_TOKEN_SUCCESS]: setSocialToken,
  [INF_SET_ASSOCIATED_FBPAGE_REQUEST]: setEntityAssociatedFBPage,
  [INF_SET_ASSOCIATED_FBPAGE_SUCCESS]: setEntityAssociatedFBPage,
  [INF_CLEAR_SOCIAL_TOKEN_REQUEST]: clearEntitySocialToken,
  [INF_CLEAR_SOCIAL_TOKEN_SUCCESS]: clearEntitySocialToken,
  [INF_SET_TWITTER_ACC_TOKEN_SUCCESS]: setSocialToken,
  [INF_SET_YOUTUBE_ACC_TOKEN_SUCCESS]: setSocialToken,
};

export default createReducer(functionMap, initialState);
